<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <div class="z-title z-title--small">
            Configurar forma de pagamento
          </div>

          <p class="z-text spacer-bottom-l">
            {{ student.first_name }}, precisamos que você nos informe a forma de pagamento das mensalidades do
            curso de {{ currentBilling.course_name }} na {{ institutionName }}.
            <br>
            Não se preocupe, você pode alterar a forma de pagamento na hora que quiser, através do painel Quero Pago.
          </p>

          <alert-box ref="alertBox" class="spacer-bottom-l" />

          <div class="bsd-section">
            <div class="payment-methods-wrapper">
              <action-card
                title="Cartão de crédito"
                icon="credit-card-blank"
                class="payment-methods__action-card"
                @click="goToCreditPaymentMethod()"
                v-if="showPaymentMethod('credit_card')"
              />

              <action-card
                title="Pix"
                icon="qrcode"
                class="payment-methods__action-card"
                @click="definePaymentMethod('Pix')"
                v-if="showPaymentMethod('pix')"
              />

              <action-card
                title="Boleto"
                icon="barcode-alt"
                class="payment-methods__action-card"
                @click="definePaymentMethod('Boleto')"
                v-if="showPaymentMethod('boleto')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.payment-methods-wrapper {
  display: flex;
  gap: var(--space-medium);
  flex-direction: column;

  @media (min-width: $screen-xs-min) {
    flex-direction: row;
  }
}

.payment-methods__action-card {
  flex: 1;
  height: 144px;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AlertBox from 'components/zilla/alert-box';
import ActionCard from 'components/action-card';
import BillingService from 'services/BillingService';
import RecurrentPaymentMethodService from 'services/RecurrentPaymentMethodService';

export default {
  components: {
    ActionCard,
    AlertBox,
  },
  data() {
    return {
      whatsappNumber: '0800 291 7878',
    };
  },
  computed: {
    ...mapState([
      'student',
      'currentBilling',
    ]),
    ...mapGetters([
      'permittedPaymentMethods',
    ]),
    canChangeDueDay() {
      return this.currentBilling.can_change_due_day;
    },
    institutionName() {
      return this.currentBilling.institution_name;
    },
  },
  methods: {
    ...mapActions([
      'loadBillings',
    ]),
    definePaymentMethod(paymentMethod) {
      this.$tracker.logEvent(`[payment configuration] Clicked "${paymentMethod}"`);
      this.$pageLoader.wrap(this.updatePaymentMethod(paymentMethod), 'Salvando forma de pagamento');
    },
    updatePaymentMethod(paymentMethod) {
      const methodName = `enable${paymentMethod}`;

      return RecurrentPaymentMethodService[methodName](this.currentBilling.id)
        .then(() => {
          this.redirectToNextStep();
        })
        .catch(() => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            `Houve um problema ao configurar a forma de pagamento. \
            Por favor, entre em contato com o Quero Pago pelo Whatsapp: ${this.whatsappNumber}`,
          );
        });
    },
    showPaymentMethod(paymentMethod) {
      return this.permittedPaymentMethods.includes(paymentMethod);
    },
    checkPaymentMethods() {
      if (this.permittedPaymentMethods.length === 1) {
        const paymentMethod = this.permittedPaymentMethods[0];
        if (paymentMethod === 'credit_card') {
          this.$router.push({ name: 'payment-configuration-credit-card', query: { 'first-config': true } });
        } else {
          this.$pageLoader.wrap(this.updatePaymentMethod(), 'Salvando informações');
          BillingService.updateConfigured(this.currentBilling.id);
          this.loadBillings();
        }
      }
    },
    redirectToNextStep() {
      if (this.canChangeDueDay) {
        this.$router.push({ name: 'payment-configuration-due-day' });
      } else if (this.permittedPaymentMethods.length === 1) {
        this.$router.push({ name: 'panel' });
      } else {
        this.$router.push({ name: 'payment-configuration-confirmation' });
      }
    },
    goToCreditPaymentMethod() {
      this.$tracker.logEvent('[payment configuration] Clicked "Cartão de crédito"');
      this.$router.push({ name: 'payment-configuration-credit-card' });
    },
  },
  created() {
    this.checkPaymentMethods();
  },
  mounted() {
    this.$tracker.logEvent('[payment configuration] Viewed Payment Configuration Page');
  },
};
</script>
